import { render, staticRenderFns } from "./tagsTable.vue?vue&type=template&id=feb2e1b8&scoped=true"
import script from "./tagsTable.vue?vue&type=script&lang=js"
export * from "./tagsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb2e1b8",
  null
  
)

export default component.exports